import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

//Primereact components
import { Toast } from 'primereact/toast';
import { Toolbar } from 'primereact/toolbar';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Calendar } from 'primereact/calendar';
import { Tag } from 'primereact/tag';
import { ColumnGroup } from 'primereact/columngroup';
import { Row } from 'primereact/row';

// Data table
import { defaultRowOptions, defaultPageRowOptions, paginatorLinks, showingEntries, Skeletonitems, SkeletonbodyTemplate, accBankTypes, convertDateFrom } from '../../../appconfig/Settings';
import { AccountTabs } from './../AccountTabs';
import { amountFormate, convertSingleYear } from '../../../appconfig/AppHelper';
import { getAllDetails, getAllDetailsDirect } from '../../../service/ProductService';
import { creditTemplate, dateTemplate, debitTemplate, remarkTemplate } from '../../../appconfig/DatatableTemplateSetting';
import { DOWNLOADVOUCHER, GETCASHENTRY, GETVOUCHERS } from '../../../config/ApiConstant';
import { CashEntryListColumns } from '../../../appconfig/DatatableSetting';
import moment from 'moment';
import Loader from '../../../components/Loadeer/Loader';

export const CashEntry = () => {
    document.title = 'Cash Entry | GSPC';

    //Set Toast/ Filter Properties
    const toast = useRef<any>(null);
    const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);
    const [globalFilter, setGlobalFilter] = useState<any>(null);

    const navigate = useNavigate();

    //Loading/Page Loading
    const [pageLoad, setPageLoad] = useState<boolean>(true);
    const [loading, setLoading] = useState<boolean>(false);

    let today = new Date();
    const [date, setDate] = useState<string | Date | Date[] | any | null>(new Date());
    const [cashEntryList, setCashEntryList] = useState<any>([]);
    const [voucher, setVoucher] = useState<any>(null);
    const [showLoader, setShowLoader] = useState<boolean>(false);
    const [credit, setCredit] = useState<any>(0);
    const [debit, setDebit] = useState<any>(0);

    // On show click
    const onShowClick = async () => {
        try {
            setPageLoad(false);
            setShowLoader(true);
            const response = await getAllDetailsDirect(GETCASHENTRY + '?date=' + convertDateFrom(date) + '&AccSrNo=-1');
            if (response) {
                setPageLoad(true);
                setShowLoader(false);
                setCashEntryList(response.List);
                setCredit(Number(response?.credit));
                setDebit(Number(response?.dabit));
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setPageLoad(true);
                setShowLoader(false);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Something Went Wrong' });
            }
        }
    };

    // Global search
    const leftToolbarTemplate = () => {
        return (
            <>
                <Calendar
                    value={date}
                    dateFormat="dd-mm-yy"
                    onChange={(e: any) => {
                        setDate(e.value);
                    }}
                    showIcon
                />
                <Button label="Show" onClick={() => onShowClick()} className="ml-2" loading={showLoader} />
                {!window.cn(voucher) ? (
                    <>
                        <Tag className="ml-5" severity="info" value={'Voucher : ' + voucher}></Tag>
                    </>
                ) : (
                    <></>
                )}
            </>
        );
    };

    //Clear All Filter
    const clearAll = () => {
        setGlobalFieldFilter(null);
        setDate(new Date());
        setCashEntryList([]);
    };

    // Right toolbar
    const rightToolbarTemplate = () => {
        return (
            <>
                <Button label="Add Cash Entry" icon="pi pi-plus" onClick={() => goToAddCashPage()} className="mr-2"></Button>
                <Button icon="pi pi-filter-slash" label="Clear" onClick={() => clearAll()} className="p-button-outlined"></Button>
            </>
        );
    };

    // goToAddCashkPage
    const goToAddCashPage = () => {
        window.open('/app/account/add-cash-entry', '_blank');
    };

    // Datatable footer group
    const footerGroup = () => {
        return cashEntryList.length > 0 ? (
            <ColumnGroup>
                <Row>
                    <Column footer={<b>Total:</b>} colSpan={5} footerStyle={{ textAlign: 'left' }} />
                    <Column footer={<b>{amountFormate(debit) + '.00'}</b>} />
                    <Column footer={<b>{amountFormate(credit) + '.00'}</b>} />
                    <Column footer={''} colSpan={2} />
                </Row>
            </ColumnGroup>
        ) : (
            <></>
        );
    };

    // Download bank entry
    const downloadBankEntry = async (id: any) => {
        try {
            setLoading(true);

            const response = await getAllDetails(DOWNLOADVOUCHER + '?id=' + id);

            //Check response and download
            if (response) {
                //PDF Download
                const fileName = `Cash-Entry-Voucher-${new Date().getTime()}.pdf`;
                const link = document.createElement('a');
                link.href = response;
                link.target = '_blank';
                link.download = fileName;
                document.body.appendChild(link);
                link.click();
                setLoading(false);
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setLoading(false);

                setShowLoader(false);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Something Went Wrong' });
            }
        }
    };

    // Template for actions
    const actionsTemplate = (rowData: any, rowIndex: any) => {
        return (
            <>
                <Button icon="pi pi-download" onClick={() => downloadBankEntry(rowData.id)} tooltip="Download" tooltipOptions={{ position: 'top' }} />
            </>
        );
    };

    return (
        <>
            <AccountTabs mainTabLabel="Cash Entry" />

            <Toast ref={toast} />
            <div className="grid crud-demo mt-2">
                <div className="col-12">
                    <div className="card">
                        <Toolbar left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
                        {/* Datatable */}
                        {pageLoad ? (
                            <>
                                <DataTable
                                    value={cashEntryList}
                                    showGridlines
                                    stripedRows
                                    globalFilter={globalFilter}
                                    filters={globalFieldFilter}
                                    onFilter={(e) => setGlobalFieldFilter(e.filters)}
                                    rows={defaultRowOptions}
                                    paginator={cashEntryList.length >= 10 && true}
                                    rowsPerPageOptions={defaultPageRowOptions}
                                    className="datatable-responsive p-datatable-sm"
                                    paginatorTemplate={paginatorLinks}
                                    currentPageReportTemplate={showingEntries}
                                    emptyMessage="No Data Found"
                                    footerColumnGroup={footerGroup()}
                                >
                                    {CashEntryListColumns.map((col, i) => {
                                        if (col.field === 'action') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={actionsTemplate} />;
                                        } else if (col.field === 'Debit') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={debitTemplate} />;
                                        } else if (col.field === 'Credit') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={creditTemplate} />;
                                        } else if (col.field === 'CurrDate') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={dateTemplate} style={{ minWidth: '8rem' }} />;
                                        } else if (col.field === 'RefNo') {
                                            return <Column key={col.field} field={col.field} header={col.header} style={{ minWidth: '8rem' }} />;
                                        } else if (col.field === 'sr_no') {
                                            return <Column key={col.field} header={col.header} body={(_, { rowIndex }) => rowIndex + 1} style={{ minWidth: '5rem' }} />;
                                        } else {
                                            return <Column key={col.field} field={col.field} header={col.header} />;
                                        }
                                    })}
                                </DataTable>
                            </>
                        ) : (
                            <>
                                {/* Skeleton Data table */}
                                <DataTable value={Skeletonitems}>
                                    {CashEntryListColumns.map((col, i) => (
                                        <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                                    ))}
                                </DataTable>
                            </>
                        )}
                    </div>
                </div>
            </div>

            {loading && <Loader />}
        </>
    );
};
